import { Bar, BarChart, CartesianGrid, Cell, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { MuniSpinner2 } from "../../../../components";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { format, parse } from "date-fns";
import { es } from "date-fns/locale";


const InfraccionesPorMes = ({ estadisticas }) => {
    const { loads } = useGeneralAppStore();
    const maxTotal = estadisticas?.reduce((prev, current) => {
        return current.total > prev.total ? current : prev;
    });

    const date = parse(maxTotal?.fecha, 'yyyy-MM', new Date());
    const monthName = format(date, 'MMMM', { locale: es });
    const capitalizeMonth = monthName?.charAt(0).toUpperCase() + monthName?.slice(1);
    const year = format(date, 'yyyy');

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-white p-3 rounded border border-1 border-dark d-flex flex-column gap-2 shadow-lg" style={{ maxWidth: "300px" }}>
                    <div>
                        <p className=" m-0 fw-bold text-primary">{`Dirección:`}</p>
                        <span className=" m-0 fw-semibold ">{`${payload[0].payload.direccion}`}</span>
                    </div>
                    <div>
                        <p className=" m-0 fw-bold text-primary">{`Cámara`}</p>
                        <p className=" m-0 fw-semibold">{`${payload[0].payload.name}`}</p>
                    </div>
                    <div>
                        <p className=" m-0 fw-bold text-primary">{`Infracciones`}</p>
                        <p className=" m-0 fw-semibold">{`${payload[0].value}`}</p>
                    </div>
                </div>
            );
        }

        return null;
    };

    // useEffect(() => {
    //     setMesMasInfraccion(estadisticas?.reduce((prev, current) => {
    //         return prev.total > current.total ? prev : current;
    //     }).fecha)
    // }, [])

    return (
        <section className=" col-12 mx-auto py-5">
            {/* <div className="d-flex justify-content-end">
                <h6 className="d-flex justify-content-center m-0 " style={{ width: "95%" }}>Infracciones por mes</h6>
            </div> */}
            <div style={{ height: "530px" }} >
                {
                    loads.includes('estadisticas')
                        ?
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                            <MuniSpinner2 />
                        </div>
                        : <ResponsiveContainer width="100%" height={350} /* style={{ overflow: "scroll" }} */>
                            <ComposedChart
                                data={estadisticas}
                                width={500}
                                height={400}
                                margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
                            >
                                <CartesianGrid stroke="#F5F5F5" />
                                <XAxis dataKey="fecha" />
                                <YAxis />
                                <Tooltip />
                                <legend />
                                {/* <Tooltip content={<CustomTooltip />} /> */}
                                {/* <Bar
                                    label={{ position: 'top', fill: "#111", fontWeight: "bold" }}
                                    barSize={45}
                                    dataKey="infracciones"
                                    isAnimationActive={false}>
                                    {
                                        estadisticas.map((data, index) => {
                                            return (
                                                <Cell cursor="pointer" fill={colors[index]} key={`cell-${index}`} />
                                            )
                                        })
                                    }
                                </Bar> */}
                                <Bar dataKey="total" barSize={25} fill="#1134C9" />
                                <Line type="monotone" dataKey="total" stroke="#ff7300" />
                            </ComposedChart>
                        </ResponsiveContainer>


                }
                <div className=" d-flex justify-content-center mt-4 ms-5" style={{width:"fit-content"}}>
                    <div>
                        <span className="fw-bold fs-5">Mes con mas infracciones</span>
                        <div className="d-flex gap-2 ">
                            <h2 className="m-0">{year}</h2>
                            <h2 className="m-0">-</h2>
                            <h2 className="m-0">{capitalizeMonth}</h2>
                        </div>
                        <h5>{maxTotal.total} - infracciones</h5>
                    </div>
                </div>

            </div>
        </section>
    );
}
export default InfraccionesPorMes;